import { FlexContainer } from '@emarketer/componentlibrary';
import styled from 'styled-components';
import { COLOR } from '../../../theme/constants';
import TextInput from '../TextInput/TextInput';

export const SearchBarContainer = styled(FlexContainer)<{ active: boolean }>`
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border: 1px solid;
  padding: 0 10px;
  border-color: ${(p) => (p.active ? COLOR.BLACK : COLOR.LIGHTGREY )};

  ${(p) =>
    p.active
      ? `
    background: #f1f8ff;
  `
      : ``}

  &::hover {
    border-color: ${COLOR.BLACK};
  }
`;

export const SearchTextInput = styled(TextInput)`
  border: none;
  width: 100%;
  padding: 10px 0;
  &:focus-visible {
    outline: none;
    background: transparent;
  }
`;
